import React, { Component } from 'react';
import { API } from 'aws-amplify';
import "tabler-react/dist/Tabler.css";
import { Card, Dimmer } from "tabler-react";

import { Page, Icon } from "tabler-react";

import CardCurso from "./CardCurso";

class Actividades extends Component {
	constructor(props){
		super(props);
		this.state = {
			data:[],
			isLoading: true,
			blackboard: JSON.parse(localStorage.getItem('blackboard'))
		};
	}

	componentDidMount = async () => {
		if (this.state.blackboard.isBlackboard === false) {
			const docenteInfo = JSON.parse(localStorage.getItem('profile'));
			let alumnosData = [];
			let alumnosBloqueadosData = [];
			let alumnosMasterData = [];
			let cursosData = [];
			for(let nivel of docenteInfo.nivel) {
				const respuestaApiAlumnosBloqueados = await API.post('apiMisCursos', '/obtenerAlumnosMoodle', {
					body: {
						nivel: nivel,
						username: docenteInfo.username,
						tipo: "alumnosBloqueados"
					}
				});
				
				if (respuestaApiAlumnosBloqueados.status) {
					Array.prototype.push.apply(alumnosBloqueadosData, respuestaApiAlumnosBloqueados.data.alumnosBloqueados);
				}

				const respuestaApiAlumnos = await API.post('apiMisCursos', '/obtenerAlumnosMoodle', {
					body: {
						nivel: nivel,
						username: docenteInfo.username,
						tipo: "alumnos"
					}
				});

				if (respuestaApiAlumnos.status) {
					Array.prototype.push.apply(alumnosData, respuestaApiAlumnos.data.alumnos);

					const respuestaApiAlumnosMaster = await API.post('apiMisCursos', '/obtenerAlumnosMoodle', {
						body: {
							nivel: nivel,
							username: docenteInfo.username,
							tipo: "alumnosMaster",
							matriculas: respuestaApiAlumnos.data.matriculas
						}
					});
					const respuestaApiCursos = await API.post('apiMisCursos', '/obtenerAlumnosMoodle', {
						body: {
							nivel: nivel,
							username: docenteInfo.username,
							tipo: "cursos",
							cursoUnico: respuestaApiAlumnos.data.cursoUnico
						}
					});
					if (respuestaApiAlumnosMaster.status) {
						Array.prototype.push.apply(alumnosMasterData, respuestaApiAlumnosMaster.data.alumnosMaster);
					}
					if (respuestaApiCursos.status) {
						Array.prototype.push.apply(cursosData, respuestaApiCursos.data.cursos);
					}
				}
			}
			let respuestaApi = {status: true, data: {alumnos: alumnosData, alumnosBloqueados: alumnosBloqueadosData, alumnosMaster: alumnosMasterData, cursos: cursosData}}
			this.setState({
				data: respuestaApi,
				cursos: respuestaApi.data.cursos,
				isLoading: false
			});
		} else {
			this.setState({isLoading: false});
		}
		
	}

	render() {
		let cards = [];
		if (this.state.cursos === undefined || this.state.cursos === 'undefined') {
		} else {
			for (let index in this.state.cursos) {
				let idTablaResultado = "resultadosCurso_" + this.state.cursos[index].cursosId;
				// let nivel  = this.state.cursos[index].nivel === 'lic' ? 'Licenciatura' : this.state.cursos[index].nivel === 'mtr' ? 'Maestría' : 'Doctorado';
				let nivel = ''
				if(this.state.cursos[index].nivel == 'lic') {
					nivel = 'Licenciatura'
				} else if(this.state.cursos[index].nivel == 'mtr') {
					nivel = 'Maestría'
				} else if(this.state.cursos[index].nivel == 'doc') {
					nivel = 'Doctorado'
				} else if(this.state.cursos[index].nivel == 'onsite') {
					nivel = 'Onsite'
				}
				let nombreCard = this.state.cursos[index].cursosNombres + " - " + nivel;
				cards.push(<CardCurso curso={this.state.cursos[index]} data={this.state.data} idTablaResultado={idTablaResultado} nombreCard={nombreCard}/>);
			}
		}
		return(
			<>
				{/* Validando BlackBoard*/}
				{ this.state.blackboard.isBlackboard === true ? (
					<div class="row">
						<div class="col-md-4"></div>
						<div class="col-md-4" style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '100vh'}}>
							<span>Próximamente para Blackboard</span>
						</div>
						<div class="col-md-4"></div>
					</div>
				):(
					<Dimmer loader active={this.state.isLoading}>
						<Page.Content className="page-repore-actividades">
								<Page.Title><Icon prefix="fe" name="edit-2" />Reporte de actividades</Page.Title>
								{cards}
						</Page.Content>
					</Dimmer>
				)
				}
				
			</>
		);
	}

}
export default Actividades;